import './action/teleconsent.action';
import './manager/teleconsent.manager';

import 'angular-xeditable';
import 'angular-xeditable/dist/css/xeditable.css';
import { RenderWithWrapper } from '../../../global/global.react';
import { LeaveModal } from '../../../modules/teleconsent/components/leave-modal';
import ReactDOM from "react-dom";

importAngularTemplates(
  require.context('./', true, /\.html$/),
  'realtime/components/teleconsent'
);

const componentName = 'teleconsent';
const serviceName = 'TeleconsentRealtimeComponent';
const moduleName = 'doxy.realtime.components.teleconsent';

export { componentName, serviceName, moduleName };
export default angular
  .module(moduleName, [
    'xeditable',
    'doxy.realtime.components.teleconsent.action',
    'doxy.realtime.components.teleconsent.manager',
  ])
  .directive('ngReallyClick', function ($window) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('click', function () {
          var message = attrs.ngReallyMessage;
          if (message && $window.confirm(message)) {
            scope.$apply(attrs.ngReallyClick);
          }
        });
      },
    };
  })
  .directive('ngLeaveTeleconsent', function () {
    return {
      restrict: 'A',
      scope: {
        ngLeaveTeleconsent: '&',
        ngLeaveTeleconsentContinue: '&',
        ngLeaveTeleconsentContinueText: '@',
        ngLeaveTeleconsentTitle: '@',
        ngLeaveTeleconsentMessage: '@'
      },
      link: function (scope, element) {
        element.bind('click', () => {
          const onContinue = () => {
            ReactDOM.unmountComponentAtNode(element[0]);
            scope.ngLeaveTeleconsentContinue();
          };
          const onLeave = () => {
            ReactDOM.unmountComponentAtNode(element[0]);
            scope.ngLeaveTeleconsent();
          };
          RenderWithWrapper(LeaveModal, {
            isOpen: true,
            title: scope.ngLeaveTeleconsentTitle,
            message: scope.ngLeaveTeleconsentMessage,
            continueText: scope.ngLeaveTeleconsentContinueText,
            onContinue,
            onLeave
          }, element[0], scope);
        });
      }
    };
  }).name;
